import axios from '@/api/api-request'

const projectUrl = '/webManufacturer'

/**
 * 生产单位管理-增加操作
 */
export const save = (data) => {
  return axios.request({
    url: projectUrl + '/add.do',
    method: 'post',
    data: data
  })
}

/**
 * 生产单位管理-删除操作
 * @param data
 */
export const deletk = (data) => {
  return axios.request({
    url: projectUrl + '/delete.do',
    method: 'post',
    params: data
  })
}
/**
 * 生产单位管理-修改操作
 * @param data
 */
export const edit = (data) => {
  return axios.request({
    url: projectUrl + '/edit.do',
    method: 'post',
    data: data
  })
}
/**
 * 生产单位管理-获取实体信息
 * @param data
 */
export const getInfo = (data) => {
  return axios.request({
    url: projectUrl + '/getInfo.do',
    method: 'post',
    data: data
  })
}
/**
 * 生产单位管理-获取全部列表
 * @param data
 */
export const getLists = (data) => {
  return axios.request({
    url: projectUrl + '/getLists.do',
    method: 'post',
    data: data
  })
}
/**
 * 生产单位管理-获取分页列表
 * @param data
 */
export const list = (data) => {
  return axios.request({
    url: projectUrl + '/list.do',
    method: 'post',
    data: data
  })
}
